<div class="wrapper">
    <div class="addContact">
        <app-type-ahead-contacts
            [searchParameters]="typeAheadSearchByEntityParameters"
            (selectedContactChange)="onSelectedContact($event)"
        ></app-type-ahead-contacts>
    </div>

    @if (contactsDatasource) {
        <div class="grid">
            <app-server-side-grid
                [colDefs]="gridColumns"
                [datasource]="contactsDatasource"
                [noRows]="noResults()"
                [titleNoData]="'No Contacts available.'"
                [getRowId]="getRowIdFn"
            ></app-server-side-grid>
        </div>
    }
</div>
